import styled from "styled-components";
import {
  PRIMARY_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.three}px;
`;

export const GapWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.two}px;
`;

export const BoostTitle = styled.div`
  display: flex;
`;

export const BoostValueWrapper = styled.div`
  text-align: center;
  border-radius: ${BORDER_RADIUS.three}px;
  background: ${PRIMARY_COLORS.three};
  border: 1px solid ${PRIMARY_COLORS.one};
  padding: ${SPACING.one}px;
  color: ${TEXT_COLORS.one};
`;

export const ExtraFarmBoostWrapper = styled.div`
  display: flex;
  width: 100%;
  background: ${PRIMARY_COLORS.four};
  border-radius: 8px;
  height: 48px;
  padding: 8px;
  gap: 8px;
  margin-top: ${SPACING.three}px;
  align-items: center;
`;

export const LogoContainer = styled.div`
  display: flex;
  min-width: 32px;
  min-height: 32px;
  border-radius: ${BORDER_RADIUS.full}px;
  background: ${PRIMARY_COLORS.one};
  align-items: center;
  justify-content: center;
  svg {
    stroke: ${PRIMARY_COLORS.on};
  }
`;

export const TextWrapper = styled.div`
  ${FONT_CSS.body.five}
  color: ${TEXT_COLORS.two};
`;
